import { apiClient } from '@/shared/api';
import { UserCreate, UserListResponse, UserPasswordUpdate, UserResponse, UserUpdate } from './types';

/**
 * Fetch users list with filters and pagination per OpenAPI GET /user
 */
export const fetchUsers = async (params?: {
  isActive?: boolean | null;
  name?: string | null;
  email?: string | null;
  limit?: number;
  offset?: number;
}) => {
  const { data } = await apiClient.get<UserListResponse>('/user', { params });
  return data;
};

/**
 * Fetch a user by ID per OpenAPI GET /user/{user_id}
 */
export const fetchUserById = async (userId: number) => {
  const { data } = await apiClient.get<UserResponse>(`/user/${userId}`);
  return data;
};

/**
 * Create a user per OpenAPI POST /user
 * Об отказе сообщает карточка пользователя: по правилам пароля — у поля пароля, прочие — уведомлением,
 * поэтому общее уведомление не поднимается.
 */
export const createUser = async (payload: UserCreate) => {
  const { data } = await apiClient.post<UserResponse>('/user', payload, { silentError: true });
  return data;
};

/**
 * Update a user per OpenAPI PUT /users/{user_id}
 */
export const updateUser = async (input: { id: number } & UserUpdate) => {
  const { id, ...payload } = input;
  const { data } = await apiClient.put<UserResponse>(`/user/${id}`, payload);
  return data;
};

/**
 * Сброс пароля пользователя администратором (PUT /user/{user_id}/password).
 * Об отказе сообщает блок сброса пароля: по правилам пароля — у поля, прочие — уведомлением,
 * поэтому общее уведомление не поднимается.
 */
export const updateUserPassword = async (params: { id: number; body: UserPasswordUpdate }) => {
  await apiClient.put<void>(`/user/${params.id}/password`, params.body, { silentError: true });
};

/**
 * Установка постоянного пароля текущим пользователем (PUT /user/me/password).
 * Об отказе сообщает окно установки пароля под своими полями, поэтому общее уведомление не поднимается.
 */
export const setOwnPassword = async (payload: UserPasswordUpdate) => {
  await apiClient.put<void>('/user/me/password', payload, { silentError: true });
};
